import React, { ButtonHTMLAttributes } from 'react';
import Button from '../Button/Button';
import Icon from '../Icon/Icon';
import Tooltip from '../Tooltip';
import styles from './CopyLinkIconButton.module.css';

export type CopyLinkIconButtonState = 'idle' | 'loading' | 'success';

const PRIMARY_ICON_COLOR = 'var(--color-brand-primary)';

interface CopyLinkIconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  state: CopyLinkIconButtonState;
  ariaLabel?: string;
}

const CopyLinkIconButton: React.FC<CopyLinkIconButtonProps> = ({
  state,
  ariaLabel = 'Copiar link',
  className = '',
  disabled,
  ...rest
}) => {
  const iconName = state === 'success' ? 'check' : 'content_copy';
  const isLoading = state === 'loading';

  return (
    <Tooltip content={ariaLabel}>
      <Button
        type="button"
        variant="primary"
        size="xs"
        className={`${styles.button} ${className}`.trim()}
        disabled={disabled || isLoading}
        aria-label={ariaLabel}
        {...rest}
      >
        {isLoading ? (
          <Icon
            name="progress_activity"
            size={14}
            color={PRIMARY_ICON_COLOR}
            className={styles.spinner}
          />
        ) : (
          <Icon name={iconName} size={14} color={PRIMARY_ICON_COLOR} />
        )}
      </Button>
    </Tooltip>
  );
};

export default CopyLinkIconButton;
